import {
  Avatar,
  Box,
  Dialog,
  DialogContent,
  DialogTitle,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  Typography,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import React from "react";
import Button from "./Button";
const ClinicModal = ({ isOpen, onClose, clinics, label }) => {
  const theme = useTheme();
  return (
    <Dialog open={isOpen} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle
        sx={{
          textAlign: "center",
          fontWeight: "bold",
          fontSize: "1.5rem",
          color: theme.palette.mode === "dark" ? "white" : "black",
        }}
      >
        Clinic Details
      </DialogTitle>
      <DialogContent>
        <Typography
          variant="body1"
          gutterBottom
          sx={{
            textAlign: "center",
            marginBottom: "1.5rem",
            color: theme.palette.mode === "dark" ? "white" : "black",
          }}
        >
          Activation status: {label}  
        </Typography>

        {/* Scrollable List */}
        <Box sx={{ maxHeight: "300px", overflowY: "auto" }}>
          <List>
            {clinics.map((clinic, index) => (
              <ListItem key={index} sx={{ borderBottom: "1px solid #ddd" }}>
                <ListItemAvatar>
                  <Avatar
                    sx={{
                      bgcolor:
                        theme.palette.mode === "dark"
                          ? theme.palette.primary.dark
                          : theme.palette.primary.main,
                      color: "white",
                    }}
                  >
                    {clinic.name.charAt(0)}
                  </Avatar>
                </ListItemAvatar>
                <ListItemText
                  primary={
                    <Typography
                      variant="h6"
                      sx={{
                        fontWeight: "bold",
                        color:
                          theme.palette.mode === "dark"
                            ? theme.palette.primary.dark
                            : theme.palette.primary.main,
                      }}
                    >
                      {clinic.name}
                    </Typography>
                  }
                  secondary={
                    <Typography
                      sx={{
                        color: theme.palette.mode === "dark" ? "white" : "#555",
                      }}
                    >
                      <strong>City:</strong> {clinic.city}
                    </Typography>
                  }
                />
              </ListItem>
            ))}
          </List>
        </Box>

        {/* Close Button */}
        <Box
          sx={{
            marginTop: "1.5rem",
            display: "flex",
            justifyContent: "center",
          }}
        >
          <Button
            onClick={onClose}
            variant="contained"
            color="primary"
            text="Close"
          />
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default ClinicModal;
